import {Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-insomnia-egypt19',
  templateUrl: './insomnia-egypt19.component.html',
  styleUrls: ['./insomnia-egypt19.component.css']
})
export class InsomniaEgypt19Component implements OnInit {
  mobileView: boolean = false;
  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  games: Array<any> = ['clash-royale','fortnite', 'dota-2', 'league-of-legends','mortal-kombat-11', 'overwatch', 'rainbow-six-siege','fifa'];


  constructor(private globalService:GlobalService,private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService,private titleService:Title) {
    this.titleService.setTitle('Insomnia-egypt19')
    if (this.globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {
    this.eventService.insomniaGame = this.router.url.split('/')[2];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });
    if (this.router.url.split('/').length < 3) {
      this.router.navigateByUrl('/insomnia-egypt19/clash-royale');
    }
  }


  getBanner(game) {
    if (game == 'home') {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/insomnia-banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/insomnia-banner.jpg';
    } else {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner.jpg';
    }
  }
}
